module.exports = __webpack_public_path__ + "static/revat-2-db2724df8c9d1e7701c2687ac237c649.png";